import { changeI18nLanguage } from '@/languages/utils';

import '@ibsaas/rd-login/rd-login.css';

changeI18nLanguage().then(() => {
  import('./index');
});
